import { supabase } from '@/core/database/supabase';
import { enforceSettingsPermission } from '@/modules/settings/permissions/enforceSettingsPermission';
import type { AccountRecord } from '../types/accounts.types';

export const accountsListService = {
  async getAccounts(companyId: string): Promise<AccountRecord[]> {
    await enforceSettingsPermission('settings.account.view', { companyId });
    
    const { data, error } = await supabase
      .from('settings_accounts')
      .select('*')
      .eq('company_id', companyId)
      .order('is_default', { ascending: false })
      .order('created_at', { ascending: false });

    if (error) throw error;
    
    return (data || []).map(item => ({
      id: item.id,
      companyId: item.company_id,
      accountName: item.account_name,
      accountNumber: item.account_number,
      bankName: item.bank_name,
      bankBranch: item.bank_branch,
      accountHolder: item.account_holder,
      currency: item.currency,
      initialBalance: Number(item.initial_balance),
      currentBalance: Number(item.current_balance),
      status: item.status,
      isDefault: item.is_default,
      description: item.description,
      createdAt: item.created_at,
      updatedAt: item.updated_at,
      createdBy: item.created_by
    }));
  },

  async deleteAccount(id: string) {
    await enforceSettingsPermission('settings.account.delete');
    const { error } = await supabase
      .from('settings_accounts')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};
